export default {
  "content": "<path d=\"M4.837 16.223a1.778 1.778 0 110 3.556 1.778 1.778 0 010-3.556zM21.001 19H9v-2h12.001v2zM4.837 10.223a1.778 1.778 0 110 3.556 1.778 1.778 0 010-3.556zM21.001 13H9v-2h12.001v2zM4.777 4.223a1.778 1.778 0 110 3.556 1.778 1.778 0 010-3.556zM21.001 7H9V5h12.001v2z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};